import { useState } from 'react';
import { AuthLayout } from '../../../components/layouts';
import { Link, useNavigate } from 'react-router-dom';
import AuthService from '../../../services/auth.service';
import { toast } from 'react-toastify';
import { KeyRound, Mail } from 'lucide-react';
import AuthInput from '../../../components/ui/AuthInput';
import AuthPrimaryButton from '../../../components/ui/AuthPrimaryButton';

export default function ForgotPassword() {
    const authService = new AuthService();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: '' });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await authService.forgotPassword(formData);
            setLoading(false);
            if (!response.status) {
                toast.error(response?.message);
                return;
            }
            toast.success(`${response?.message}: a new password has been sent to your email.`);
            navigate('/parent/sign-in');
        } catch (err: any) {
            setLoading(false);
            toast.error(err.message);
        }
    };

    return (
        <AuthLayout>
            <div className="mb-6 text-center">
                <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-ryd-primaryLess1 text-ryd-primary">
                    <KeyRound size={20} />
                </div>
                <h1 className="font-[AvertaStd-Semibold] text-[22px] text-ryd-headerTextPrimary sm:text-[26px]">
                    Reset Password
                </h1>
                <p className="mt-1.5 px-1 text-[13px] text-[#8b9aab] sm:text-[14px]">
                    Enter your email and we&apos;ll send you a new password.
                </p>
            </div>

            <form className="space-y-4" onSubmit={handleSubmit}>
                <AuthInput
                    label="Email Address"
                    type="email"
                    placeholder="example@email.com"
                    required
                    leftIcon={<Mail size={18} />}
                    value={formData.email}
                    onChange={(e) => setFormData({ email: e.target.value })}
                />

                <AuthPrimaryButton loading={loading}>Continue</AuthPrimaryButton>

                <p className="pt-1 text-center text-[14px] text-[#8b9aab]">
                    Remembered your password?{' '}
                    <Link to="/parent/sign-in" className="font-semibold text-ryd-primary hover:underline">
                        Back to Login
                    </Link>
                </p>
            </form>
        </AuthLayout>
    );
}
